import { nanoid } from 'nanoid'
import { type ActionItem, toastStore } from 'shared/ui'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { logger } from 'shared/lib'
import { type RowInvite } from 'entities/Users/model/Table/RowInvite'
import { UsersApi } from 'entities/Users/api/users'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { type IResponseCancelInvite } from 'entities/Users/api/types'
import { CancelInviteStore } from 'pages/settings/pages/members/ui/actions/cancelInvite/ui'

export const cancelInvite = (
  entities: IEntitiesStore,
  invites: RowInvite[],
  onSuccess?: (response: IResponseCancelInvite) => void | Promise<void>,
  bulk?: {
    all: boolean
    search: string
    total: number
  }
): ActionItem => {
  const count = bulk?.all ? bulk.total : invites.length

  const inviteText = count === 1 ? 'invite' : 'invites'

  return {
    text: `Cancel ${inviteText}`,
    icon: 'delete',
    onAction: async () => {
      let hasSeat = false
      let seats_count = 0
      if (bulk?.all) {
        try {
          const { data } = await UsersApi.calculateInvitesSeats({
            ids: [],
            search: bulk.search,
            all: true,
          })
          seats_count = data.seats_count
          hasSeat = seats_count > 0
        } catch (e) {
          logger.error(e)
        }
      } else {
        hasSeat = invites.some((invite) => invite.hasSeat)
      }
      if (hasSeat) {
        new CancelInviteStore(entities, invites, seats_count, onSuccess, bulk)
      } else {
        const modalId = nanoid()

        modalStore.addModal({
          id: modalId,
          type: ModalTypeList.ALERT,
          title: `Cancel ${count > 1 ? `${count} ` : ''}${inviteText}?`,
          primaryAction: {
            text: `Yes, cancel ${inviteText}`,
            onAction: async () => {
              try {
                if (!invites.length && !bulk?.all) return
                const { data } = await UsersApi.cancelInvite(
                  bulk?.all
                    ? { all: true, search: bulk.search }
                    : {
                        ids: invites.map((item) => item.id),
                      }
                )

                onSuccess?.(data)
                modalStore.closeModal(modalId)
              } catch (error) {
                logger.error(error)

                toastStore.add({
                  type: 'error',
                  title: 'Failed to cancel invitation. Please try again',
                })
              }
            },
          },
          secondaryAction: {
            text: `Keep ${inviteText}`,
            onAction: () => {
              modalStore.closeModal(modalId)
            },
          },
        })
      }
    },
  }
}
